export default "__VITE_ASSET__a69468ee__"